import { OfferOrderService } from "../../explorer/services/OfferOrderService";
import { CustomBasketService } from "../services/CustomBasketService";
import { CustomOrderOfferService } from "../services/CustomOrderOfferService";
import { CustomSparePartsService } from "../services/CustomSparePartsService";
import { CustomSystemService } from "../services/CustomSystemService";
import { WarrantyService } from "../services/WarrantyService";

export class ServiceProvider {
  static readonly System: CustomSystemService = new CustomSystemService();
  static readonly SpareParts: CustomSparePartsService = new CustomSparePartsService();
  static readonly Basket: CustomBasketService = new CustomBasketService();
  static readonly OfferOrder: OfferOrderService = new OfferOrderService();
  static readonly Warranty: WarrantyService = new WarrantyService();
  static readonly OrderOffer: CustomOrderOfferService =
    new CustomOrderOfferService();
}

export default ServiceProvider;
